import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Audience, AudienceStatus } from "@front/m19-api-client";
import { Marketplaces } from "@front/m19-models";
import { AccountSelectionService, AuthService, FAILED_AUDIENCE_STATUSES } from "@front/m19-services";
import { IBadgeComponent, IButtonDirective, IIconComponent, ITooltipDirective } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { DragIconComponent } from "@m19-board/shared/drag-icon/drag-icon.component";
import { map } from "rxjs";

@Component({
  selector: "app-dsp-audience-line",
  imports: [
    CommonModule,
    IButtonDirective,
    ITooltipDirective,
    TranslocoDirective,
    IBadgeComponent,
    DragIconComponent,
    IIconComponent,
  ],
  templateUrl: "./dsp-audience-line.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspAudienceLineComponent {
  private readonly accountSelection = inject(AccountSelectionService);
  private readonly authService = inject(AuthService);
  marketplaceCurrency = toSignal(
    this.accountSelection.singleAccountMarketplaceSelection$.pipe(map((am) => Marketplaces[am.marketplace].currency)),
  );
  locale = toSignal(this.authService.loggedUser$.pipe(map((user) => user.locale)));

  audience = input.required<Audience>();

  isInAudienceGroup = input<boolean>(false);
  isLastInGroup = input<boolean>(false);
  isPlaceholder = input<boolean>(false);
  isDragPreview = input<boolean>(false);
  isReadOnly = input<boolean>(false);
  drawBottomBorder = input<boolean>(true);
  excluded = input<boolean>(false);
  operator = input<"and" | "or">("or");
  displayFee = input<boolean>(true);

  clicked = output<void>();

  isActive = computed(() => !this.audience().status || this.audience().status === AudienceStatus.Active);
  isFailed = computed(() => FAILED_AUDIENCE_STATUSES.includes(this.audience().status));
  isMovable = computed(() => !this.isReadOnly() && !this.isInAudienceGroup() && !this.isPlaceholder());
}
